import CryptoJS from 'crypto-js';
import { useEffect } from "react";
import { useLocation } from 'react-router-dom';

export const generateSerieNumber = (length = 12) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };
  
// Générer un timestamp en clair
export const generateTimestamp = () => {
const now = new Date();
const year = now.getFullYear();
const month = String(now.getMonth() + 1).padStart(2, '0');
const day = String(now.getDate()).padStart(2, '0');
const hours = String(now.getHours()).padStart(2, '0');
const minutes = String(now.getMinutes()).padStart(2, '0');
const seconds = String(now.getSeconds()).padStart(2, '0');
const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};

// Crypter le timestamp
export const encryptTimestamp = (timestamp, password) => {
const key = CryptoJS.MD5(password).toString();
const encrypted = CryptoJS.HmacSHA1(timestamp, key).toString(CryptoJS.enc.Hex);
return encrypted.toLowerCase().replace(/\s+/g, '');
};

// Fonction pour analyser le XML
export const parseXML = (xml) => {
const parser = new DOMParser();
const xmlDoc = parser.parseFromString(xml, "text/xml");
return xmlDoc;
};

export const parseFrenchDate = (dateString) => {
  const [day, month, year] = dateString.split('/').map(Number);
  return new Date(year, month - 1, day);
};

export const ScrollToAnchor = () => {
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
};

